var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 17",
    height: 17,
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5BB3C7",
    stroke: "#F6F6F6",
    d: "M7.7,10l19.5,0c1,0,1.8-0.7,1.8-1.5C29,7.7,28.2,7,27.2,7H7.7V4.3c0-0.7-1-1-1.5-0.5L1.3,8 C0.9,8.3,0.9,8.7,1.3,9l4.9,4.2c0.5,0.5,1.5,0.1,1.5-0.5V10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bf63ef51db2f28ca5c8c9a7a2b1734a5.svg";
export { ForwardRef as ReactComponent };